// extracted by mini-css-extract-plugin
export default {"root":"kBnsP8Eke1b5vY1rhdiW","placeHolderShimmer":"V23DJanJscGX4M_KMrRB"};